const a = { aria_label: "Buscar", clear: "Borrar", placeholder_article: "", placeholder_header: "Buscar artículos" }, r = {
  searcher: a
};
export {
  r as default,
  a as searcher
};
//# sourceMappingURL=help-center-articles-search34.js.map
